module.exports = __webpack_public_path__ + "img/#2-gallery.5df01d8f.jpg";